import Loading from '../loading/Loading.jsx';
import MergedTableHeader from '../dataGrid/MergedTableHeader.jsx';
import Pagination from '../dataGrid/Pagination.jsx';

import { useState, useEffect } from 'react';
import axios from 'axios';
import '../../../css/data-grid.css';
import { useSubIcon } from '../../../hooks/useSubIcon.js';
import { useDynamicStyle } from '../../../hooks/useDynamicStyle.js';

const DataGridClickedPopup = ({ propsInfo, state, pageInfo, setPageInfo, mergeConfig, searchParams, popupPropsInfo, gridHeight, ver, flag }) => {

    const dataList = state.dataList;
    const isSearched = state.isSearched;
    const isLoading = state.isLoading;

    const dataHead = propsInfo.dataHead;
    const dataColumn = propsInfo.dataColumn;
    const colWidth = propsInfo.colWidth;
    const tdWrap = propsInfo.wrapTF;

    const paginationTF = pageInfo.paginationTF;

    const [emog, setEmog] = useState([]);

    const onHandlePage = (page) => {
        if (page !== pageInfo.currentPage) {
            setPageInfo(prev => ({
                ...prev,
                currentPage: page
            }));
        }
    };

    const paginationInfo = {
        ...pageInfo,
        onPageChange: onHandlePage,
    }

    const computeRowSpans = (dataList, mergeConfig = [], allColumns = []) => {
        const rowSpans = dataList.map(() => ({}));
        // 병합 기준이 되는 마스터 컬럼
        const masterMerge = mergeConfig.find(m => m.row === null);
        const masterKey = masterMerge?.key;
        // 1. 기준 컬럼 기준으로 병합 구간 나누기
        const mergeBlocks = [];
        let blockStart = 0;
        for (let i = 1; i <= dataList.length; i++) {
            const curr = dataList[i];
            const prev = dataList[i - 1];
            const isSameGroup =
                i < dataList.length &&
                dataList[i][masterKey] === dataList[i - 1][masterKey] &&
                dataList[i][masterKey] !== null &&
                dataList[i][masterKey] !== '';
            if (!isSameGroup) {
                mergeBlocks.push({ start: blockStart, end: i });
                blockStart = i;
            }
        }
        // 2. 기준 컬럼 병합 수행
        mergeBlocks.forEach(({ start, end }) => {
            const masterValue = dataList[start][masterKey];
            rowSpans[start][masterKey] = end - start;
            for (let i = start + 1; i < end; i++) {
                rowSpans[i][masterKey] = 0;
            }
            // 3. 그 외 병합 대상 칼럼 처리
            mergeConfig.forEach(({ key: colKey, row, nullable }) => {
                if (colKey === masterKey) return;
                let prevValue = null;
                let localStart = start;
                let mergeCount = 1;
                for (let i = start; i < end; i++) {
                    const currVal = dataList[i][colKey];
                    const isMergeable = nullable
                        ? currVal === prevValue
                        : currVal === prevValue && currVal !== '' && currVal !== null;
                    if (i === start) {
                        rowSpans[i][colKey] = 1;
                        prevValue = currVal;
                        continue;
                    }
                    if (isMergeable) {
                        rowSpans[localStart][colKey] += 1;
                        rowSpans[i][colKey] = 0;
                        mergeCount += 1;
                    } else {
                        rowSpans[i][colKey] = 1;
                        localStart = i;
                        mergeCount = 1;
                        prevValue = currVal;
                    }
                }
            });
        });
        // 4. 병합 대상이 아닌 컬럼 처리
        dataList.forEach((_, i) => {
            allColumns.forEach(colKey => {
                if (!(colKey in rowSpans[i])) {
                    rowSpans[i][colKey] = 1;
                }
            });
        });
        return rowSpans;
    };

    const fetchEmogList = async () => {
        try {
            const response = await axios.get('/ptmiapi/emogList.do', {
                params: {
                    grdc: '',
                    loca: '',
                }
            });
            setEmog(response.data.emogList || []);
        } catch (error) {
            console.error('병원 목록 로딩 중 오류 발생:', error);
        }
    };

    const rowSpans = computeRowSpans(dataList, mergeConfig ?? [], dataColumn);

    // Dynamic Style Hook
    const { lightBackColor, borderColorGray, hoverLightFontColor } = useDynamicStyle();

    // icon list
    const { EmptyIcon, NullIcon } = useSubIcon();

    useEffect(() => {
        fetchEmogList();
    }, []);

    return (
        <div className='data_grid_container'>
            {isLoading ? <Loading /> :
                <>
                    <hr className={`border-t-2 mr-1-1 ${borderColorGray}`} />
                    <div className={`data_list_table ${tdWrap && 'td_wrap'} ${isSearched ? 'grid-animation' : ''}`}>
                        <table>
                            {colWidth !== undefined &&
                                <colgroup>
                                    {colWidth.length > 0 && colWidth.map((per, idx) => <col key={idx} width={per} /> )}
                                </colgroup>
                            }
                            <MergedTableHeader
                                headers={dataHead}
                            />
                            <tbody>
                                {dataList.length === 0 ? (
                                    <tr>
                                        <td colSpan={1000} style={{ padding: '0' }}>
                                            <span className={`data_empty ${lightBackColor}`}>
                                                {isSearched ? EmptyIcon : NullIcon}
                                                {isSearched ? '해당하는 데이터가 없습니다.' : '검색 버튼을 눌러 데이터를 조회하세요.'}
                                            </span>
                                        </td>
                                    </tr>
                                ) : (
                                    dataList.map((item, rowIndex) => {
                                        const gridColor = rowIndex % 2 === 0 ? lightBackColor : '';
                                        return (
                                            <tr key={rowIndex} className={gridColor}>
                                                {dataColumn.map((col, colIndex) => {
                                                    const span = rowSpans[rowIndex][col];
                                                    if (!span) return null;

                                                    const prefix = dataList[rowIndex].DNAME === '합계' ? null : col.split('_')[0];
                                                    const isClickable = popupPropsInfo.checked.includes(prefix);
                                                    const prevalue = searchParams.searchEmog;
                                                    const handleClick = () => {
                                                        const senData = !flag ?
                                                            {
                                                                searchType: col.split('_')[0],
                                                                searchGubun: dataList[rowIndex][col],
                                                                flag: popupPropsInfo.flag
                                                            } :
                                                            {
                                                                searchGrdc: dataList[rowIndex].DNAME,
                                                                searchFromdate: dataList[rowIndex].TT1,
                                                                searchDateCls: dataList[rowIndex].TT3,
                                                                emogcode: emog.find((a) => a.EMOGDESC === dataList[rowIndex].DNAME)?.EMOGCODE,
                                                            }
                                                        searchParams.searchEmog = '';
                                                        if (dataList[rowIndex].TRMSEMNM !== "전체") {
                                                            searchParams.searchEmog = dataList[rowIndex].TRMSEMCD;
                                                        }
                                                        const totalObj = Object.assign({}, searchParams, senData);

                                                        let popup = null;

                                                        if (isSearched) {
                                                            localStorage.setItem(popupPropsInfo.localStorageName, JSON.stringify(totalObj));
                                                            popup = window.open(popupPropsInfo.popupAddress, "팝업", `scrollbars=${ver === 'trmsVisit' ? 0 : 1}, resizable=0, width=${ver === 'trmsVisit' ? 700 : 1200}, height=${ver === 'trmsVisit' ? 450 : 561}, left=${ver === 'trmsVisit' ? 2500 : 30} ,top=${ver === 'trmsVisit' ? 300 : 30}`);
                                                        }
                                                        searchParams.searchEmog = prevalue;
                                                    };

                                                    const cellStyle = (dataList[rowIndex].TRMSEMCD === 'A00' ? 'bold ' : '')
                                                        + (isClickable ? `underline-pointer ${hoverLightFontColor}` : '');

                                                    return (
                                                        <td
                                                            key={colIndex}
                                                            rowSpan={span}
                                                            onClick={isClickable ? handleClick : undefined}
                                                            className={cellStyle}
                                                        >
                                                            {item[col]}
                                                        </td>
                                                    );
                                                })}
                                            </tr>
                                        )
                                    })
                                )}
                            </tbody>
                        </table>
                    </div>
                    <hr className='mr-1-1 co_border_gray' />
                    {dataList.length === 0 || !paginationTF ? (
                        <br />
                    ) : (
                        <Pagination
                            paginationInfo={paginationInfo}
                        />
                    )}
                </>
            }
        </div>
    );
};

export default DataGridClickedPopup;